import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";

const rootElement = document.getElementById("root");
const tree = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// When the page ships prerendered HTML (from scripts/prerender.js), React
// hydrates on top of it, preserving the static markup for SEO crawlers while
// attaching interactivity for real users. Otherwise (dev server, or direct
// browser requests that bypass static files), fall back to a clean render.
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, tree);
} else {
  ReactDOM.createRoot(rootElement).render(tree);
}
